import uuid from 'uuid/v4';

export const version = () => '4.0.4';

// export const getDUID = () => {
//    if (window.navigator.userAgent) {
//     return 'BD-TIZEN-WEB';
//   }
//   return webapis.productinfo.getDuid().toUpperCase();
// };


export const getDUID = () => webapis.productinfo.getDuid().toUpperCase();

export const getDeviceId = () => {
  // NOTE: This is for backwards compatibility and can be removed once all users are using the new version of the app.
  // Old versions of the app stored the tizenDeviceId in localStorage and this allows the new version of our store
  // to use that existing device id, so that users do not have to re-pair.
  const currentDeviceId = localStorage.getItem('tizenDeviceId');
  localStorage.removeItem('tizenDeviceId');

  if (currentDeviceId !== null) {
    return currentDeviceId;
  }

  const newId = getDUID();
  return newId;
};
